// extracted by mini-css-extract-plugin
export default {"external-links":"ExternalLinks_external-links__U2+4j","external-links__title":"ExternalLinks_external-links__title__LgmgR"};